import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Lock } from 'products/global/assets/img/icons/av-lock.svg';
import { motion, AnimatePresence } from 'framer-motion';
import { TabWrapper, StyledTab, DisabledOverlay } from './styled';

const Tab = ({ isActive, item, onClick }) => {
  const { name, disabled, icon, label } = item;

  return (
    <TabWrapper key={`tab-${name}`} isActive={isActive}>
      <StyledTab
        isActive={isActive}
        disabled={disabled}
        onClick={!disabled ? onClick : undefined}
      >
        {icon}
        {disabled && (
          <DisabledOverlay>
            <Lock />
          </DisabledOverlay>
        )}
      </StyledTab>
      {!disabled && (
        <AnimatePresence>
          {isActive && (
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: 'auto', transition: { duration: 0.4 } }}
              exit={{ width: 0, transition: { duration: 0.4 } }}
            >
              <span>{label}</span>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </TabWrapper>
  );
};

Tab.propTypes = {
  isActive: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export default Tab;
